import { render, staticRenderFns } from "./PlotLineLegendBar.vue?vue&type=template&id=5497adf8&scoped=true&"
import script from "./PlotLineLegendBar.vue?vue&type=script&lang=js&"
export * from "./PlotLineLegendBar.vue?vue&type=script&lang=js&"
import style0 from "./PlotLineLegendBar.vue?vue&type=style&index=0&id=5497adf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5497adf8",
  null
  
)

export default component.exports